import Api from './api'

const resource = '/images'
export default {
  create(file) {
    let formData = new FormData();
    formData.append('file', file);
    return Api.post(`${resource}/store`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
